import {Sport} from '../App'

export const getTeamLogo = (team: string, sport: Sport) => {
    try {
      return require(`../logos/${sport}/${team}.png`);
    } catch (error) {
      console.error(`Logo for team ${team} not found`);
      return null;
    }
  };